module.exports = __webpack_public_path__ + "static/media/firmecard.a023247e.svg";